__turbopack_context__.v({
  "select": "Select-module__G1y7Eq__select",
});
